import { ColorField } from "./ColorField";
import { NUMBER_PLACEMENTS } from "../../lib/shield";

export const NumberStyle = ({ player, accent, onChange }) => (
  <div className="space-y-3 border-2 border-dashed border-slate-200 p-3" data-testid="number-style">
    <div className="text-sm font-bold">Shirt number placement</div>
    <div className="grid grid-cols-3 gap-1.5">
      {NUMBER_PLACEMENTS.map(([id, label]) => (
        <button key={id} type="button" onClick={() => onChange({ numberPlacement: id })} data-testid={`number-placement-${id}`}
          aria-pressed={(player.numberPlacement || "behind") === id}
          className={`border-2 px-2 py-1.5 text-[11px] font-bold uppercase ${(player.numberPlacement || "behind") === id ? "border-slate-900 bg-slate-900 text-white" : "border-slate-200 hover:border-slate-900"}`}>{label}</button>
      ))}
    </div>
    <div className="flex flex-wrap items-end gap-3">
      <ColorField id="number" label="Number colour" value={player.numberColor || accent} onChange={(numberColor) => onChange({ numberColor })} />
      {player.numberColor && (
        <button type="button" onClick={() => onChange({ numberColor: "" })} className="pb-1 text-xs font-bold uppercase text-slate-500 underline hover:text-slate-900" data-testid="number-color-reset">
          Use accent colour
        </button>
      )}
    </div>
  </div>
);
